import React from "react";

function RescheduleLog() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#d3dcfb"
        d="M246.23 426.666H51.191c-18.851 0-34.132-15.282-34.132-34.132V358.4h261.957z"
        data-original="#d3dcfb"
      ></path>
      <path
        fill="#ebf5fc"
        d="M460.825 153.6v238.932H51.191c-18.851 0-34.132-15.282-34.132-34.133V153.6l238.95-85.334z"
        data-original="#ebf5fc"
      ></path>
      <path
        fill="#3c58a0"
        d="M77.336 221.867H59.203a8 8 0 01-8-8v-18.133a8 8 0 018-8h18.133a8 8 0 018 8v18.133a8 8 0 01-8 8zm68.267 0H127.47a8 8 0 01-8-8v-18.133a8 8 0 018-8h18.133a8 8 0 018 8v18.133a8 8 0 01-8 8zm68.266 0h-18.133a8 8 0 01-8-8v-18.133a8 8 0 018-8h18.133a8 8 0 018 8v18.133a8 8 0 01-8 8zm68.267 0h-18.133a8 8 0 01-8-8v-18.133a8 8 0 018-8h18.133a8 8 0 018 8v18.133a8 8 0 01-8 8zm68.255 0h-18.133a8 8 0 01-8-8v-18.133a8 8 0 018-8h18.133a8 8 0 018 8v18.133a8 8 0 01-8 8zm68.267 0h-18.133a8 8 0 01-8-8v-18.133a8 8 0 018-8h18.133a8 8 0 018 8v18.133a8 8 0 01-8 8zM77.336 290.133H59.203a8 8 0 01-8-8V264a8 8 0 018-8h18.133a8 8 0 018 8v18.133a8 8 0 01-8 8zm68.267 0H127.47a8 8 0 01-8-8V264a8 8 0 018-8h18.133a8 8 0 018 8v18.133a8 8 0 01-8 8zm68.266 0h-18.133a8 8 0 01-8-8V264a8 8 0 018-8h18.133a8 8 0 018 8v18.133a8 8 0 01-8 8zm76.267 0v-25.6a8.533 8.533 0 00-8.533-8.533h-17.067a8.533 8.533 0 00-8.533 8.533V281.6a8.533 8.533 0 008.533 8.533zM77.336 358.4H59.203a8 8 0 01-8-8v-18.133a8 8 0 018-8h18.133a8 8 0 018 8V350.4a8 8 0 01-8 8zm68.267 0H127.47a8 8 0 01-8-8v-18.133a8 8 0 018-8h18.133a8 8 0 018 8V350.4a8 8 0 01-8 8zm68.266 0h-18.133a8 8 0 01-8-8v-18.133a8 8 0 018-8h18.133a8 8 0 018 8V350.4a8 8 0 01-8 8z"
        data-original="#3c58a0"
      ></path>
      <path
        fill="#2a428c"
        d="M418.417 187.733h-17.65c-1.068 0-2.085.21-3.022.579a8.237 8.237 0 015.219 7.662v17.65c0 3.484-2.165 6.456-5.219 7.662.937.37 1.954.58 3.022.58h17.65a8.242 8.242 0 008.242-8.241v-17.65a8.243 8.243 0 00-8.242-8.242zm-68.267 0H332.5c-1.068 0-2.085.21-3.022.579a8.237 8.237 0 015.219 7.662v17.65c0 3.484-2.165 6.456-5.219 7.662.937.37 1.954.58 3.022.58h17.65a8.24 8.24 0 008.241-8.241v-17.65a8.241 8.241 0 00-8.241-8.242zm-68.255 0h-17.65c-1.068 0-2.085.21-3.022.579 3.055 1.206 5.22 4.178 5.22 7.662v17.65c0 3.484-2.165 6.456-5.22 7.662.937.37 1.954.58 3.022.58h17.65a8.242 8.242 0 008.242-8.241v-17.65a8.243 8.243 0 00-8.242-8.242zm-68.267 0h-17.65c-1.068 0-2.085.21-3.022.579 3.055 1.206 5.22 4.178 5.22 7.662v17.65c0 3.484-2.165 6.456-5.22 7.662.937.37 1.954.58 3.022.58h17.65a8.242 8.242 0 008.242-8.241v-17.65a8.243 8.243 0 00-8.242-8.242zm-68.267 0h-17.65c-1.068 0-2.085.21-3.022.579a8.237 8.237 0 015.219 7.662v17.65c0 3.484-2.165 6.456-5.219 7.662.937.37 1.954.58 3.022.58h17.65a8.242 8.242 0 008.242-8.241v-17.65a8.242 8.242 0 00-8.242-8.242zm-68.266 0h-17.65c-1.068 0-2.085.21-3.022.579 3.055 1.206 5.22 4.178 5.22 7.662v17.65c0 3.484-2.165 6.456-5.22 7.662.937.37 1.954.58 3.022.58h17.65a8.242 8.242 0 008.242-8.241v-17.65a8.243 8.243 0 00-8.242-8.242zm0 68.267h-17.65c-1.068 0-2.085.21-3.022.579 3.055 1.206 5.22 4.178 5.22 7.662v17.651c0 3.484-2.165 6.456-5.22 7.662.937.37 1.954.58 3.022.58h17.65a8.242 8.242 0 008.242-8.241v-17.651A8.243 8.243 0 0077.095 256zm0 68.267h-17.65c-1.068 0-2.085.21-3.022.579 3.055 1.206 5.22 4.178 5.22 7.662v17.651c0 3.484-2.165 6.456-5.22 7.662.937.37 1.954.58 3.022.58h17.65a8.242 8.242 0 008.242-8.241v-17.651a8.243 8.243 0 00-8.242-8.242zM145.361 256h-17.65c-1.068 0-2.085.21-3.022.579a8.237 8.237 0 015.219 7.662v17.651c0 3.484-2.165 6.456-5.219 7.662.937.37 1.954.58 3.022.58h17.65a8.242 8.242 0 008.242-8.241v-17.651a8.242 8.242 0 00-8.242-8.242zm0 68.267h-17.65c-1.068 0-2.085.21-3.022.579a8.237 8.237 0 015.219 7.662v17.651c0 3.484-2.165 6.456-5.219 7.662.937.37 1.954.58 3.022.58h17.65a8.242 8.242 0 008.242-8.241v-17.651a8.241 8.241 0 00-8.242-8.242zM213.628 256h-17.65c-1.068 0-2.085.21-3.022.579 3.055 1.206 5.22 4.178 5.22 7.662v17.651c0 3.484-2.165 6.456-5.22 7.662.937.37 1.954.58 3.022.58h17.65a8.242 8.242 0 008.242-8.241v-17.651a8.243 8.243 0 00-8.242-8.242zm76.508 34.133v-25.892a8.241 8.241 0 00-8.242-8.241h-17.65c-1.068 0-2.085.21-3.022.579 3.055 1.206 5.22 4.178 5.22 7.662v17.651c0 3.484-2.165 6.456-5.22 7.662.937.37 1.954.58 3.022.58h25.892zm-76.508 34.134h-17.65c-1.068 0-2.085.21-3.022.579 3.055 1.206 5.22 4.178 5.22 7.662v17.651c0 3.484-2.165 6.456-5.22 7.662.937.37 1.954.58 3.022.58h17.65a8.242 8.242 0 008.242-8.241v-17.651a8.242 8.242 0 00-8.242-8.242z"
        data-original="#2a428c"
      ></path>
      <path
        fill="#d3dcfb"
        d="M437.114 143.721v248.812h23.711V153.6z"
        data-original="#d3dcfb"
      ></path>
      <path
        fill="#ff4155"
        d="M460.825 153.6V68.266c0-18.851-15.282-34.132-34.132-34.132H51.191c-18.851 0-34.132 15.281-34.132 34.132V153.6z"
        data-original="#ff4155"
      ></path>
      <path
        fill="#e80054"
        d="M124.609 75.993h-22.217a7.726 7.726 0 110-15.452h22.217a7.726 7.726 0 110 15.452zm54.582 0h-22.217a7.726 7.726 0 110-15.452h22.217c4.268 0 7.726 3.459 7.726 7.726s-3.458 7.726-7.726 7.726zm141.696 0h-22.218a7.726 7.726 0 110-15.452h22.218c4.268 0 7.726 3.459 7.726 7.726s-3.458 7.726-7.726 7.726zm54.583 0h-22.218a7.726 7.726 0 110-15.452h22.218a7.726 7.726 0 110 15.452z"
        data-original="#e80054"
      ></path>
      <path
        fill="#ebf5fc"
        d="M162.125 64c0 11.782-9.551 21.333-21.333 21.333S119.459 75.782 119.459 64V21.333C119.458 9.551 129.009 0 140.791 0s21.333 9.551 21.333 21.333V64zm196.278 0c0 11.782-9.551 21.333-21.333 21.333S315.736 75.782 315.736 64V21.333C315.736 9.551 325.287 0 337.069 0s21.333 9.551 21.333 21.333V64z"
        data-original="#ebf5fc"
      ></path>
      <path
        fill="#d3dcfb"
        d="M337.069 0c-4.38 0-8.448 1.324-11.836 3.588 5.725 3.826 9.498 10.343 9.498 17.746V64c0 7.402-3.773 13.92-9.498 17.746a21.233 21.233 0 0011.836 3.588c11.782 0 21.333-9.551 21.333-21.333V21.333C358.403 9.551 348.852 0 337.069 0zM140.791 0c-4.38 0-8.448 1.324-11.836 3.588 5.725 3.826 9.498 10.343 9.498 17.746V64c0 7.402-3.773 13.92-9.498 17.746a21.233 21.233 0 0011.836 3.588c11.782 0 21.333-9.551 21.333-21.333V21.333C162.125 9.551 152.574 0 140.791 0z"
        data-original="#d3dcfb"
      ></path>
      <path
        fill="#e80054"
        d="M426.693 34.133H402.99c18.851 0 34.132 15.281 34.132 34.132V153.6h23.702V68.266c.001-18.851-15.281-34.133-34.131-34.133z"
        data-original="#e80054"
      ></path>
      <path
        fill="#e80054"
        d="M17.058 111.74h443.767v15.453H17.058z"
        data-original="#e80054"
      ></path>
      <circle
        cx="366.942"
        cy="384"
        r="128"
        fill="#4fabf7"
        data-original="#4fabf7"
      ></circle>
      <circle
        cx="366.942"
        cy="384"
        r="93.867"
        fill="#ebf5fc"
        data-original="#ebf5fc"
      ></circle>
      <path
        fill="#3c58a0"
        d="M366.942 374.659a7.725 7.725 0 01-7.726-7.726v-42.667a7.726 7.726 0 1115.452 0v42.667a7.726 7.726 0 01-7.726 7.726zm42.667 17.067h-25.601a7.726 7.726 0 110-15.452h25.601a7.726 7.726 0 110 15.452z"
        data-original="#3c58a0"
      ></path>
      <path
        fill="#1886ea"
        d="M366.942 256c-3.995 0-7.945.193-11.847.551C420.232 262.53 471.247 317.303 471.247 384s-51.016 121.47-116.153 127.449c3.902.358 7.852.551 11.847.551 70.692 0 128-57.308 128-128s-57.307-128-127.999-128z"
        data-original="#1886ea"
      ></path>
      <path
        fill="#d3dcfb"
        d="M366.942 290.133c-4.01 0-7.961.253-11.839.741 46.252 5.821 82.028 45.295 82.028 93.126s-35.776 87.305-82.028 93.126c3.878.488 7.829.741 11.839.741 51.841 0 93.867-42.026 93.867-93.867s-42.026-93.867-93.867-93.867z"
        data-original="#d3dcfb"
      ></path>
      <circle
        cx="366.942"
        cy="384"
        r="17.067"
        fill="#ffdd40"
        data-original="#ffdd40"
      ></circle>
    </svg>
  );
}

export default RescheduleLog;